<dx-box #workflowSearch height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto" [visible]="!isPopupMode">
        <h2 class="page-header">
            Search Invoices
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
            <i
                class="far fa-window-restore page-launch-link dx-theme-accent-as-text-color"
                title="Open page in new window"
                (click)="openPageInWindow()"
            ></i>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="invoice-box-container cc-white-background">
        <dx-box width="100%" height="100%" direction="col" class="invoice-container">
            <dxi-item baseSize="auto" *ngIf="showFullFilters && !showLimitedFilters">
                <dx-form
                    #invoiceForm
                    width="100%"
                    height="100%"
                    class="invoice-form-group"
                    labelLocation="left"
                    [colCount]="1"
                >
                    <dxi-item itemType="group" [visible]="!selectedContext" [colCount]="4">
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-short">Community</div>
                                <div class="dx-field-value field-component-medium">
                                    <app-multi-column-selector
                                        [name]="'Community'"
                                        [cssClass]="'community-width'"
                                        [gridSource]="communityList"
                                        [boxValue]="communityGridBoxValue"
                                        [valueExpr]="'communityId'"
                                        [displayExpr]="'communityName'"
                                        [columnDef]="communityColumns"
                                        [dropDownButtonTemplate]="'dropDownButton'"
                                        [dropDownOptions]="{ width: 'auto' }"
                                        [showClearButton]="true"
                                        [navigateToCommunity]="true"
                                        [placeholder]="'All Communities...'"
                                        [showHeaderFilters]="true"
                                        (gridSelectionEvent)="onCommunitySelection($event)"
                                    ></app-multi-column-selector>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-medium">Include Terminated</div>
                                <div class="dx-field-value field-component-short">
                                    <dx-radio-group
                                        displayExpr="displayName"
                                        valueExpr="value"
                                        layout="horizontal"
                                        [items]="terminatedOptions"
                                        [(value)]="workflowSearchParameterDto.includeTerminated"
                                    ></dx-radio-group>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-long">Location</div>
                                <div class="dx-field-value field-component-medium">
                                    <dx-select-box
                                        displayExpr="displayName"
                                        valueExpr="id"
                                        placeholder="All Locations"
                                        [disabled]="disableLocationSelection"
                                        [hint]="getLocationHint()"
                                        [searchEnabled]="true"
                                        [dataSource]="locations"
                                        [showClearButton]="true"
                                        [(value)]="workflowSearchParameterDto.locationId"
                                        (onValueChanged)="onLocationChange()"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-long">Management Company</div>
                                <div class="dx-field-value field-component-medium">
                                    <dx-select-box
                                        displayExpr="displayName"
                                        valueExpr="id"
                                        placeholder="All Management Companies"
                                        [disabled]="disableManagementCompanySelection"
                                        [hint]="getManagementCompanyHint()"
                                        [searchEnabled]="true"
                                        [showClearButton]="true"
                                        [dataSource]="managementCompanyList"
                                        [(value)]="workflowSearchParameterDto.managementCompanyId"
                                        (onValueChanged)="onManagementCompanyChange()"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-short">Vendor</div>
                                <div class="dx-field-value field-component-medium">
                                    <app-multi-column-selector
                                        [name]="'Vendor'"
                                        [gridSource]="vendorList"
                                        [boxValue]="vendorGridBoxValue"
                                        cssClass="vendor-width"
                                        [valueExpr]="'vendorId'"
                                        [displayExpr]="'vendorName'"
                                        [columnDef]="vendorColumns"
                                        [dropDownButtonTemplate]="'dropDownButton'"
                                        [dropDownOptions]="{ width: 400 }"
                                        [showClearButton]="true"
                                        [placeholder]="'Select Vendor'"
                                        [showGridHeaders]="false"
                                        (gridSelectionEvent)="onVendorSelection($event)"
                                    ></app-multi-column-selector>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-medium">Vendor Status</div>
                                <div class="dx-field-value field-component-short">
                                    <dx-radio-group
                                        layout="horizontal"
                                        displayExpr="displayName"
                                        valueExpr="value"
                                        [items]="vendorStatusOptions"
                                        [(value)]="selectedVendorStatusOption"
                                        (onValueChanged)="onVendorStatusChange()"
                                    ></dx-radio-group>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-long">Invoice#</div>
                                <div class="dx-field-value field-component-medium">
                                    <dx-text-box
                                        [(value)]="workflowSearchParameterDto.invoiceNumber"
                                        (onEnterKey)="onSearchRefreshClick()"
                                    ></dx-text-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-long">AAP Workflow Job Id</div>
                                <div class="dx-field-value field-component-medium">
                                    <dx-text-box
                                        [(value)]="workflowSearchParameterDto.workflowId"
                                        (onEnterKey)="onSearchRefreshClick()"
                                    ></dx-text-box>
                                </div>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-short">View</div>
                                <div class="dx-field-value field-component-medium">
                                    <dx-select-box
                                        displayExpr="displayName"
                                        valueExpr="value"
                                        [searchEnabled]="true"
                                        [dataSource]="viewList"
                                        [(value)]="workflowSearchParameterDto.myWorkOnly"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-medium">Status</div>
                                <div class="dx-field-value field-component-short">
                                    <dx-select-box
                                        [searchEnabled]="true"
                                        [dataSource]="statusOptions"
                                        [(value)]="workflowSearchParameterDto.sourceType"
                                        (onValueChanged)="onStatusChange()"
                                    ></dx-select-box>
                                </div>
                            </div>
                        </dxi-item>

                        <dxi-item [visible]="workflowSearchParameterDto.sourceType !== 'Open'">
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-long">Invoices Beginning From</div>
                                <div class="dx-field-value field-component-short">
                                    <dx-date-box
                                        openOnFieldClick="true"
                                        type="date"
                                        [showClearButton]="true"
                                        [useMaskBehavior]="true"
                                        [(value)]="workflowSearchParameterDto.fromDate"
                                    ></dx-date-box>
                                </div>
                            </div>
                        </dxi-item>

                        <dxi-item>
                            <div *dxTemplate class="field-container">
                                <div class="dx-field-label field-short">Lite Mode</div>
                                <div class="dx-field-value field-component-shorter">
                                    <dx-switch
                                        class="field-switch"
                                        [(value)]="workflowSearchParameterDto.liteMode"
                                        (onValueChanged)="onLiteModeValueChange()"
                                    ></dx-switch>
                                </div>
                                <dx-button
                                    text="Search / Refresh"
                                    type="default"
                                    [icon]="iconRefresh"
                                    (onClick)="onSearchRefreshClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto" *ngIf="!showFullFilters && showLimitedFilters">
                <dx-form
                    #invoiceForm
                    width="100%"
                    height="100%"
                    class="invoice-form-group"
                    labelLocation="left"
                    [colCount]="6"
                >
                    <dxi-item>
                        <dxo-label text="View"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayName"
                                valueExpr="value"
                                [searchEnabled]="true"
                                [dataSource]="viewList"
                                [(value)]="workflowSearchParameterDto.myWorkOnly"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Status"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                [searchEnabled]="true"
                                [dataSource]="statusOptions"
                                [(value)]="workflowSearchParameterDto.sourceType"
                                (onValueChanged)="onStatusChange()"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item [visible]="workflowSearchParameterDto.sourceType !== 'Open'" [colSpan]="2">
                        <dxo-label text="Invoices Beginning From"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                openOnFieldClick="true"
                                type="date"
                                [showClearButton]="true"
                                [useMaskBehavior]="true"
                                [(value)]="workflowSearchParameterDto.fromDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Lite Mode"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                class="field-switch"
                                [(value)]="workflowSearchParameterDto.liteMode"
                                (onValueChanged)="onLiteModeValueChange()"
                            ></dx-switch>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-button
                                text="Search / Refresh"
                                type="default"
                                [icon]="iconRefresh"
                                (onClick)="onSearchRefreshClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="grid-container">
                        <cc-data-grid-features
                            #invoiceGrid
                            [stateConfig]="{
                                storageKey: 'SEARCH_INVOICE_GRID',
                                storeGroupings: true,
                                storeSortings: true
                            }"
                            [dataSource]="searchResults"
                        >
                            <dx-data-grid
                                appHasInternalUserColumns
                                width="100%"
                                height="100%"
                                [dataSource]="searchResults"
                            >
                                <dxi-column
                                    name="InternalActions"
                                    type="buttons"
                                    caption="Action"
                                    [width]="110"
                                    [visibleIndex]="0"
                                    alignment="center"
                                    cellTemplate="actionTemplate"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    [showInColumnChooser]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="managementCompany"
                                    caption="Management Company"
                                    [visibleIndex]="1"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="location"
                                    caption="Location"
                                    [visibleIndex]="2"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="community"
                                    caption="Community"
                                    cellTemplate="communityCellTemplate"
                                    [visibleIndex]="3"
                                ></dxi-column>
                                <dxi-column
                                    name="RestrictedColumn|WORKFLOW_DETAILS"
                                    dataType="string"
                                    dataField="workFlowId"
                                    caption="Workflow Id"
                                    [visibleIndex]="4"
                                    cellTemplate="workflowCellTemplate"
                                ></dxi-column>
                                <dxi-column
                                    name="RestrictedColumn|MAINTENANCE_WORK_ORDERS"
                                    dataType="string"
                                    dataField="workOrders"
                                    caption="Work Orders"
                                    [visibleIndex]="5"
                                    cellTemplate="workOrderTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="invoiceNumber"
                                    caption="Invoice #"
                                    [visibleIndex]="6"
                                ></dxi-column>
                                <dxi-column
                                    dataType="date"
                                    dataField="invoiceDate"
                                    caption="Invoice Date"
                                    [format]="dateFormat"
                                    [visibleIndex]="7"
                                ></dxi-column>
                                <dxi-column
                                    dataType="date"
                                    dataField="datePosted"
                                    caption="Date Posted"
                                    [format]="dateFormat"
                                    [visibleIndex]="8"
                                ></dxi-column>
                                <dxi-column
                                    dataType="number"
                                    dataField="invoiceAmount"
                                    caption="Invoice Amount"
                                    [format]="currencyFormat"
                                    [visibleIndex]="9"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="workflowStatus"
                                    caption="Workflow Status"
                                    cellTemplate="workflowStatusCellTemplate"
                                    [visibleIndex]="10"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="paymentStatus"
                                    caption="Payment Status"
                                    cellTemplate="paymentStatusTemplate"
                                    [visibleIndex]="11"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="accountNumber"
                                    caption="Account"
                                    [visibleIndex]="13"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="invoiceStatus"
                                    caption="Invoice Status"
                                    [visibleIndex]="14"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    caption="Invoice"
                                    cellTemplate="invoiceFileCellTemplate"
                                    alignment="center"
                                    [visibleIndex]="15"
                                    [allowGrouping]="false"
                                ></dxi-column>
                                <dxi-column
                                    name="InternalLogs"
                                    dataType="string"
                                    caption="History"
                                    cellTemplate="historyCellTemplate"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    alignment="center"
                                    [visibleIndex]="15"
                                    [allowGrouping]="false"
                                    [allowFiltering]="false"
                                    [allowHeaderFiltering]="false"
                                    [allowSorting]="false"
                                ></dxi-column>
                                <dxi-column
                                    name="InternalNotes"
                                    dataField="hasNotes"
                                    dataType="boolean"
                                    caption="Notes"
                                    cellTemplate="notesCellTemplate"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    alignment="center"
                                    [visibleIndex]="16"
                                    [allowGrouping]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    caption="Board History"
                                    cellTemplate="boardHistoryCellTemplate"
                                    alignment="center"
                                    [visibleIndex]="17"
                                    [allowGrouping]="false"
                                    [allowFiltering]="false"
                                    [allowHeaderFiltering]="false"
                                    [allowSorting]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="boolean"
                                    dataField="hasBoardNotes"
                                    caption="Board Notes"
                                    cellTemplate="boardNotesCellTemplate"
                                    alignment="center"
                                    [visibleIndex]="18"
                                    [allowGrouping]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="communityTerminationDate"
                                    caption="Association Termination Date"
                                    [visibleIndex]="19"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="payee"
                                    caption="Vendor"
                                    [visibleIndex]="20"
                                    cellTemplate="vendorNameTemplate"
                                ></dxi-column>
                                <ng-container *ngIf="!workflowSearchParameterDto?.liteMode">
                                    <dxi-column
                                        name="InternalDashboardResponsible"
                                        dataType="string"
                                        dataField="dashboardResponsibleUsersDisplayText"
                                        caption="Dashboard Responsible Users"
                                        cellTemplate="responsibleTemplate"
                                        headerCellTemplate="lockHeaderCellTemplate"
                                        [visibleIndex]="21"
                                        [allowGrouping]="false"
                                        [visible]="!workflowSearchParameterDto?.liteMode"
                                        [showInColumnChooser]="!workflowSearchParameterDto?.liteMode"
                                    >
                                        <dxo-header-filter [dataSource]="uniqueResponsibleUsers"></dxo-header-filter>
                                    </dxi-column>
                                    <dxi-column
                                        dataType="string"
                                        dataField="addedByUsersDisplayText"
                                        caption="Initiated By"
                                        cellTemplate="addedByTemplate"
                                        [visibleIndex]="22"
                                        [allowGrouping]="false"
                                        [visible]="!workflowSearchParameterDto?.liteMode"
                                        [showInColumnChooser]="!workflowSearchParameterDto?.liteMode"
                                    ></dxi-column>
                                </ng-container>
                                <dxi-column
                                    name="InternalDashboardStatus"
                                    dataType="string"
                                    dataField="dashboardStatus"
                                    caption="Dashboard Status"
                                    headerCellTemplate="lockHeaderCellTemplate"
                                    [visibleIndex]="23"
                                    [allowGrouping]="false"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="date"
                                    dataField="dueDate"
                                    caption="Due Date"
                                    [format]="dateFormat"
                                    [visibleIndex]="24"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="boolean"
                                    dataField="eft"
                                    caption="EFT"
                                    cellTemplate="booleanCheckTemplate"
                                    [visibleIndex]="25"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="date"
                                    dataField="inboxDate"
                                    caption="Inbox Date"
                                    [format]="dateFormat"
                                    [visibleIndex]="26"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="specialHandling"
                                    caption="Special Handling"
                                    [visibleIndex]="27"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="payeeType"
                                    caption="Payee Type"
                                    [visibleIndex]="28"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="string"
                                    dataField="vendorType"
                                    caption="Vendor Type"
                                    [visibleIndex]="29"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="date"
                                    dataField="startDate"
                                    caption="Workflow Start Date"
                                    [format]="dateFormat"
                                    [visibleIndex]="30"
                                    [visible]="false"
                                ></dxi-column>
                                <dxi-column
                                    dataType="boolean"
                                    dataField="addedByCam"
                                    caption="CAM Initiated"
                                    cellTemplate="booleanCheckTemplate"
                                    [visibleIndex]="31"
                                    [visible]="false"
                                ></dxi-column>

                                <div *dxTemplate="let d of 'invoiceFileCellTemplate'">
                                    <i
                                        class="cc-1-5x icon-content cc-icon-pdf"
                                        [ngClass]="iconPDF"
                                        (click)="onDownloadFile(d.data)"
                                    ></i>
                                </div>

                                <div *dxTemplate="let d of 'booleanCheckTemplate'">
                                    <div *ngIf="d.value">
                                        <i class="cc-1-5x cc-icon-check" [ngClass]="iconCheck"></i>
                                    </div>
                                </div>

                                <div *dxTemplate="let t of 'historyCellTemplate'">
                                    <i
                                        class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                        [ngClass]="iconHistory"
                                        (click)="onHistoryClick(t.data)"
                                    ></i>
                                </div>

                                <div *dxTemplate="let d of 'notesCellTemplate'">
                                    <div *ngIf="d.data.hasNotes">
                                        <i
                                            class="cc-1-5x icon-content cc-icon-content cc-icon-check"
                                            [ngClass]="iconNotes"
                                            (click)="onNotesClick(d.data)"
                                        ></i>
                                    </div>

                                    <div *ngIf="!d.data.hasNotes">
                                        <i
                                            class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                            [ngClass]="iconEmptyNotes"
                                            (click)="onNotesClick(d.data)"
                                        ></i>
                                    </div>
                                </div>
                                <div *dxTemplate="let t of 'boardHistoryCellTemplate'">
                                    <div *ngIf="t.data.hasBoardApproval">
                                        <i
                                            class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                            [ngClass]="iconHistory"
                                            (click)="onBoardHistoryClick(t.data)"
                                        ></i>
                                    </div>
                                </div>

                                <div *dxTemplate="let d of 'boardNotesCellTemplate'">
                                    <div *ngIf="d.data.hasBoardApproval && d.data.hasBoardNotes">
                                        <i
                                            class="cc-1-5x icon-content cc-icon-content cc-icon-check"
                                            [ngClass]="iconNotes"
                                            (click)="onBoardNotesClick(d.data)"
                                        ></i>
                                    </div>
                                    <div *ngIf="d.data.hasBoardApproval && !d.data.hasBoardNotes">
                                        <i
                                            class="cc-1-5x icon-content dx-theme-accent-as-text-color"
                                            [ngClass]="iconEmptyNotes"
                                            (click)="onBoardNotesClick(d.data)"
                                        ></i>
                                    </div>
                                </div>

                                <div *dxTemplate="let r of 'responsibleTemplate'" class="responsible-container">
                                    <ng-container
                                        *ngIf="r.data.dashboardResponsibleUsers.length === 1"
                                        [ngTemplateOutlet]="singleUserTemplate"
                                        [ngTemplateOutletContext]="{
                                            data: r.data,
                                            user: r.data.dashboardResponsibleUsers[0]
                                        }"
                                    ></ng-container>
                                    <ng-container
                                        *ngIf="r.data.dashboardResponsibleUsers.length > 1"
                                        [ngTemplateOutlet]="multiUsersTemplate"
                                        [ngTemplateOutletContext]="{ data: r.data }"
                                    ></ng-container>
                                </div>

                                <div *dxTemplate="let r of 'addedByTemplate'" class="responsible-container">
                                    <ng-container
                                        [ngTemplateOutlet]="singleUserTemplate"
                                        [ngTemplateOutletContext]="{
                                            data: r.data,
                                            user: r.data.addedBy
                                        }"
                                    ></ng-container>
                                </div>

                                <div *dxTemplate="let row of 'communityCellTemplate'" class="cc-hyperlink-hover">
                                    <app-property-community-link
                                        *ngIf="row.data.community"
                                        [communityId]="row.data.communityId"
                                        [displayText]="row.value"
                                    ></app-property-community-link>
                                </div>

                                <div *dxTemplate="let d of 'workflowCellTemplate'">
                                    <app-hyperlink-creator
                                        *ngIf="d.data.workFlowId"
                                        mode="hyperlinkOnly"
                                        actionCode="WORKFLOW_DETAILS"
                                        [displayText]="d.data.workFlowId"
                                        (onLinkClick)="onWorkflowIdCellClick(d.data)"
                                    ></app-hyperlink-creator>
                                </div>

                                <div *dxTemplate="let d of 'paymentStatusTemplate'">
                                    <ng-container *ngIf="d.value === 'Paid' || d.value === 'Partially Paid'">
                                        <app-hyperlink-creator
                                            cssClass="cc-hyperlink-underline-hover"
                                            mode="hyperlinkOnly"
                                            [displayText]="d.value"
                                            (onLinkClick)="onPaidPaymentStatusClick(d.data)"
                                        ></app-hyperlink-creator>
                                    </ng-container>
                                    <ng-container *ngIf="d.value !== 'Paid' && d.value !== 'Partially Paid'">
                                        {{ d.value }}
                                    </ng-container>
                                </div>

                                <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                                    {{ header.column.caption }}
                                    <app-security-info
                                        securityIndicator="LOCK"
                                        apiAction="GET"
                                        apiUrl="api/wf/search"
                                    ></app-security-info>
                                </div>

                                <div *dxTemplate="let row of 'workflowStatusCellTemplate'">
                                    <app-workflow-status-link
                                        *ngIf="row.data.workflowStatus"
                                        [status]="row.data.workflowStatus"
                                    ></app-workflow-status-link>
                                </div>

                                <div *dxTemplate="let t of 'actionTemplate'">
                                    <app-grid-actions-menu
                                        *ngIf="hasAction(t.data)"
                                        [actionMenuItems]="actionMenuItems"
                                        [record]="t.data"
                                        [rowIndex]="t.rowIndex"
                                        [isActionVisible]="isActionItemVisible"
                                        (onActionClick)="onActionItemClick($event)"
                                    ></app-grid-actions-menu>
                                </div>

                                <div *dxTemplate="let row of 'workOrderTemplate'">
                                    <ng-container *ngIf="row?.data?.workOrderIds?.length > 0">
                                        <div *ngFor="let workOrderId of row.data.workOrderIds">
                                            <app-hyperlink-creator
                                                actionCode="MAINTENANCE_WORK_ORDERS"
                                                [displayText]="workOrderId"
                                                (onLinkClick)="onWorkOrderClick(workOrderId, row.data)"
                                            ></app-hyperlink-creator>
                                        </div>
                                    </ng-container>
                                </div>

                                <div *dxTemplate="let row of 'vendorNameTemplate'">
                                    <app-property-community-link
                                        *ngIf="row.data.payeeType === 'Community'"
                                        [communityId]="row.data.communityId"
                                        [displayText]="row.value"
                                    ></app-property-community-link>
                                    <app-property-community-link
                                        *ngIf="row.data.payeeType === 'Owner'"
                                        [communityId]="row.data.communityId"
                                        [customerId]="row.data.payeeCode"
                                        [displayText]="row.value"
                                    ></app-property-community-link>
                                    <app-hyperlink-creator
                                        *ngIf="row.data.payeeType === 'Vendor'"
                                        actionCode="VENDOR_MANAGEMENT"
                                        [displayText]="row.value"
                                        [communityId]="row.data.communityId"
                                        (onLinkClick)="onVendorNameClick(row.data)"
                                    ></app-hyperlink-creator>
                                    <span
                                        *ngIf="
                                            row.data.payeeType !== 'Community' &&
                                            row.data.payeeType !== 'Owner' &&
                                            row.data.payeeType !== 'Vendor'
                                        "
                                    >
                                        {{ row.value }}
                                    </span>
                                </div>

                                <dxo-summary>
                                    <dxi-group-item
                                        column="workFlowId"
                                        summaryType="count"
                                        displayFormat="Count = {0}"
                                    ></dxi-group-item>
                                </dxo-summary>
                            </dx-data-grid>
                        </cc-data-grid-features>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<ng-template #singleUserTemplate let-user="user" let-data="data">
    <div class="res-content">
        <app-user-bio-link [user]="user" [communityId]="data.communityId"></app-user-bio-link>
    </div>
</ng-template>

<ng-template #multiUsersTemplate let-data="data">
    <app-hyperlink-creator
        cssClass="cc-hyperlink cc-hyperlink-hover cc-hyperlink-underline-hover"
        [displayText]="data.dashboardResponsibleUsersDisplayText"
        (onLinkClick)="showUsersList(data)"
    ></app-hyperlink-creator>
</ng-template>

<app-multi-user-bio-links
    *ngIf="showUsersListPopup"
    [users]="selectedUserConfig.users"
    [communityId]="selectedUserConfig.communityId"
    [title]="selectedUserConfig.title"
    (onClose)="onUserListClose()"
></app-multi-user-bio-links>

<dx-popup
    *ngIf="!!selectedWorkflow"
    [title]="'Responsible Users for #' + selectedWorkflow?.workFlowId"
    width="20%"
    height="60%"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="showUsersListPopup"
    (onHidden)="selectedWorkflow = null"
>
    <div *dxTemplate="let data of 'content'">
        <dx-list
            selectionMode="none"
            pageLoadMode="scrollBottom"
            noDataText="No Responsible Users"
            searchExpr="displayName"
            [dataSource]="selectedWorkflow.dashboardResponsibleUsers"
            [searchEnabled]="true"
            [focusStateEnabled]="false"
            [activeStateEnabled]="false"
            [hoverStateEnabled]="false"
        >
            <div *dxTemplate="let user of 'item'" class="responsibleusers-listitem">
                <app-user-bio-link [user]="user" [communityId]="selectedWorkflow.communityId"></app-user-bio-link>
            </div>
        </dx-list>
    </div>
</dx-popup>

<dx-popup
    #workflowEditorPopup
    width="99%"
    height="99%"
    [title]="workflowEditorTitle"
    [showCloseButton]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showWorkflowEditor"
>
    <div *dxTemplate="let data of 'content'" class="workflow-content">
        <app-workflow-editor
            #workflowEditor
            *ngIf="showWorkflowEditor"
            [workflowId]="selectedWorkflow?.workFlowId"
            [communityId]="selectedWorkflow?.communityId"
            [status]="selectedWorkflow?.workflowStatus"
            [isPopupMode]="true"
            (closeParentContainer)="onWorkflowClose($event)"
        ></app-workflow-editor>
    </div>
</dx-popup>

<dx-popup
    #reverseAPBillPopup
    minWidth="150px"
    minHeight="70px"
    width="30%"
    height="20%"
    [title]="reverseAPBillPopUpTitle"
    [showCloseButton]="true"
    [shading]="true"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="showReverseAPBillPopUp"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate class="popup-field-container">
                    <div class="field-label">Reversal Date</div>
                    <div class="field-value">
                        <dx-date-box
                            openOnFieldClick="true"
                            type="date"
                            [showClearButton]="true"
                            [useMaskBehavior]="true"
                            [(value)]="reversalDate"
                        ></dx-date-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="showReverseAPBillPopUp = false"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="OK"
                                    [icon]="iconCheck"
                                    (onClick)="onReverseAPBillOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-popup
    #changeSpecialHandlingPopup
    minWidth="150px"
    minHeight="70px"
    width="30%"
    height="25%"
    [title]="changeSpecialHandlingPopUpTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="showchangeSpecialHandlingPopUp"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" [colCount]="1" labelLocation="top">
                        <dxi-item>
                            <dxo-label text="Special Handling"></dxo-label>
                            <div *dxTemplate>
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="specialHandlingId"
                                    [searchEnabled]="true"
                                    [dataSource]="specialHandlingList"
                                    [(value)]="selectedSpecialHandlingId"
                                ></dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item [isRequired]="selectedSpecialHandlingId === 2">
                            <dxo-label text="Special Instructions"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area class="textarea-content" [(value)]="specialInstruction"></dx-text-area>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="showchangeSpecialHandlingPopUp = false"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    icon="check"
                                    type="success"
                                    text="OK"
                                    (onClick)="onSpecialHandlingOkClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-workflow-notes-editor
    *ngIf="showWorkFlowNotesPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    [hasNotes]="selectedWorkflow.hasNotes"
    (closeNotesPopUp)="onWorkflowNotesPopClose($event)"
></app-workflow-notes-editor>

<app-workflow-history
    *ngIf="showWorkFlowHistoryPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowHistoryClose()"
></app-workflow-history>

<app-workflow-board-history
    *ngIf="showWorkFlowBoardHistoryPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowBoardHistoryClose()"
></app-workflow-board-history>

<app-workflow-board-notes-editor
    *ngIf="showWorkFlowBoardNotesPopUp"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (closeNotesPopUp)="onWorkdlowBoardNotesPopClose($event)"
></app-workflow-board-notes-editor>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowSearch' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-lite-mode-preference
    #liteModePreference
    [defaultMode]="true"
    [storageKey]="'SEARCH_INVOICE'"
    [pageName]="'Search Invoice'"
    (onLoad)="setStoredLiteMode($event)"
    (onChanged)="onLiteModePreferenceChange()"
></app-lite-mode-preference>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    (onClose)="onWorkflowViewerClose()"
></app-workflow-viewer>

<app-workflow-payment-history
    *ngIf="showPaymentHistory"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    [managementCompanyId]="managementCompanyId"
    (onClose)="onPaymentHistoryClose($event)"
></app-workflow-payment-history>

<app-workflow-workorder-selector
    *ngIf="showWorkOrder"
    [step]="selectedWorkflow?.workflowStatus"
    [workflowId]="selectedWorkflow.workFlowId"
    [communityId]="selectedWorkflow.communityId"
    [vendorCode]="selectedWorkflow?.payeeCode"
    [payee]="selectedWorkflow.payee"
    [workOrders]="linkedWorkOrderIds"
    (onClose)="onWorkOrderSelectorClose($event)"
></app-workflow-workorder-selector>

<app-workflow-community-attribution
    *ngIf="showCommunityAttribution"
    [workflowId]="selectedWorkflow?.workFlowId"
    [workflowStatus]="selectedWorkflow?.workflowStatus"
    (onCommunityAttribution)="onCommunityAttributionSave($event)"
    (onClose)="onCommunityAttributionClose($event)"
></app-workflow-community-attribution>

<cc-message-box #searchMessageBox></cc-message-box>

<app-detail-popups [isCorporateCirabook]="isCorporateCirabook"></app-detail-popups>
